// removed by extract-text-webpack-plugin
module.exports = {"itemListContainer":"C9rzv","itemList":"_3D04z"};